import { render } from "./QuoteDetail.vue?vue&type=template&id=957363f2"
import script from "./QuoteDetail.vue?vue&type=script&lang=js"
export * from "./QuoteDetail.vue?vue&type=script&lang=js"

import "./QuoteDetail.vue?vue&type=style&index=0&id=957363f2&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__